// SubCard.js — a bordered group inside the focus pane (e.g. People / Devices /
// Sites & cloud within Infrastructure). Optional uppercase eyebrow + hint.
// Faithful port of components/workspace/SubCard.jsx.
import React from 'react';
import { v3 } from '../../lib/styleTokens';

export function SubCard({ eyebrow, hint, children, style = {} }) {
  return (
    <div
      style={{
        background: v3.color.card,
        border: `1px solid ${v3.color.border}`,
        borderRadius: v3.radius.cardLarge,
        padding: v3.space.cardPad,
        fontFamily: v3.font.family,
        ...style,
      }}
    >
      {eyebrow && (
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, marginBottom: 16 }}>
          <h3
            style={{
              fontSize: v3.font.size.body,
              fontWeight: v3.font.weight.semibold,
              margin: 0,
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              color: v3.color.muted,
            }}
          >
            {eyebrow}
          </h3>
          {hint && <span style={{ fontSize: v3.font.size.small, color: v3.color.mutedSoft }}>{hint}</span>}
        </div>
      )}
      {children}
    </div>
  );
}
